import { render } from "./ClassroomList.vue?vue&type=template&id=2893d33b&scoped=true&ts=true"
import script from "./ClassroomList.vue?vue&type=script&lang=ts"
export * from "./ClassroomList.vue?vue&type=script&lang=ts"

import "./ClassroomList.vue?vue&type=style&index=0&id=2893d33b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2893d33b"]])

export default __exports__